import { Flex } from 'components/base/layout-components';
import styled from 'styled-components';
export const PMWidgetWrapper = styled(Flex)`
  position: absolute;
  height: 26.2rem;
  background-color: #ebeef5;
  margin-top: 6rem;
  margin-right: 1rem;
  min-width: -webkit-fill-available;
  z-index: 100;
  opacity: 0.9;
  border-radius: 0px 0px 5px 5px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const BoxWrapper = styled.div`
  position: absolute;
  height: 33rem;
  opacity: 1 !important;
  font-size: 5rem;
`;

export const ContentWrapper = styled(Flex)`
  flex-direction: column;
  margin-top: 3rem;
`;

export const ButtonWrapper = styled(Flex)`
  margin-bottom: 2.5rem;
  justify-content: center;
`;

export const CloseIconWrapper = styled(Flex)`
  justify-content: flex-end;
  width: 100%;
  font-size: 10rem;
  margin-right: 3rem;
`;
